/**
 * @generated SignedSource<<2768a8ce806a9de98301eb35241ae579>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateSalesforceVerificationKeyInput = {
  useSandbox?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createSalesforceVerificationKeyMutation$variables = {
  input: CreateSalesforceVerificationKeyInput;
};
export type createSalesforceVerificationKeyMutation$data = {
  readonly createSalesforceVerificationKey: {
    readonly key: string | null;
  } | null;
};
export type createSalesforceVerificationKeyMutation = {
  variables: createSalesforceVerificationKeyMutation$variables;
  response: createSalesforceVerificationKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateSalesforceVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createSalesforceVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createSalesforceVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createSalesforceVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9519e237cc2a257cf099bb064848b7c3",
    "id": null,
    "metadata": {},
    "name": "createSalesforceVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createSalesforceVerificationKeyMutation(\n  $input: CreateSalesforceVerificationKeyInput!\n) {\n  createSalesforceVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();

(node as any).hash = "7600fbbba8895f113be24f3555d4e645";

export default node;
